module.exports = __webpack_public_path__ + "static/media/last-node.e9b9f430.svg";